import { api } from '../api';
/**
 * 룰렛 이벤트 API
 */
export const DrawLotsApi = {
	GetDrawLotsCount: (member_se, event_se) => api.get(`/api/draw-lots/count?event_se=${event_se}&&member_se=${member_se}`),
	PostDrawLots: (data) => api.post(`api/draw-lots`, data),
};